import { inject } from '@angular/core';
import { exhaustMap } from 'rxjs';
import { Actions, createEffect, ofType } from '@ngrx/effects';

import { EasyDgdService, ShippingPaper, steps } from '@hazmatsuite-next/easydgd-lib';
import { loadDataSuccess, setTransportMode, setTransportModeSuccess } from './easydgd-data.actions';
import { Store } from '@ngrx/store';
import { EasyDgdDataState } from './easydgd-data.reducer';
import { Router } from '@angular/router';

export const setTransportModeEffect = createEffect(
  (actions$ = inject(Actions), easyDgdService = inject(EasyDgdService),
    store = inject(Store<{ easyDgdData: EasyDgdDataState }>)) => {
    return actions$.pipe(
      ofType(setTransportMode),
      exhaustMap((input) => {
        return [
          setTransportModeSuccess({ transportMode: input.transportMode }),
          loadDataSuccess({ transportMode: input.transportMode, data: new ShippingPaper() })
        ];
      }
        // store.select(state => state.data).pipe(
        //   switchMap(data => {
        //     // if(!data[input.transportMode]) {
        //     //   return easyDgdService.loadDataFromSession().pipe(
        //     //     map(data =>

        //     //     )
        //     //   )
        //     // }
        //     return of([
        //       setTransportModeSuccess({ transportMode: input.transportMode }),
        //       loadDataSuccess({ transportMode: input.transportMode, data: new ShippingPaper() })
        //     ])
        //   }
        //   )
        // )
      )
    );
  },
  { functional: true }
);

// export const initStepperEffect = createEffect(
//   (actions$ = inject(Actions), languageService = inject(LanguageService)) => {
//     return actions$.pipe(
//       ofType(initStepper),
//       exhaustMap(() => {
//         // const stepperItems = steps(languageService);
//         return of(initStepperSuccess({ steps: [] }));
//       }
//         // languageService.translations$.pipe(
//         //   filter(translation => !!translation['EasyDgdCommonResource']),
//         //   map(() => {
//         //     const stepperItems = steps(languageService)
//         //     return initStepperSuccess({ steps: stepperItems });
//         //   })
//         // )
//       )
//     );
//   },
//   { functional: true }
// );

// this.languageService.translations$.pipe(
//   takeUntil(this.translationLoadingSubject) // Keep listening until the condition is met
// ).subscribe(translations => {
//   if (translations['EasyDgdCommonResource']) {
//     const stepperItems = steps(this.languageService);
//     this.store.dispatch(init({ steps: stepperItems }));
//     this.translationLoadingSubject.next();
//   }
// });
